export default __webpack_public_path__ + "static/media/Brain Grigore.ca2190dd.png";